import { z } from "zod"

export const entityIngestEventSchema = z.object({
    action: z.string(),
    params: z.array(z.unknown()),
})

export type EntityIngestEvent = z.infer<typeof entityIngestEventSchema>
